import { css } from 'styled-components';
import { HeadingBase } from 'elements/Heading/styled';
import {
  colors,
  duration,
  ease,
  elevation,
  themed,
  isDefaultThemeMode,
} from 'core/theme';
import { padding } from '../constants';
import { CardBase } from './';


export const StyledHeading = HeadingBase.extend`
  color: currentColor;
  margin-top: 16px !important;
`;

const backgroundColor = (props) => {
  let accent;
  switch (props.accent) {
    case 'primary':
      accent = colors.P;
      break;
    case 'secondary':
      accent = colors.S;
      break;
    default:
      accent = colors.PL;
  }
  const defaultThemed = Object.assign({}, colors.lightThemed, {
    light: accent,
  });
  return themed(defaultThemed);
};

const color = (props) => {
  const defaultThemed = Object.assign({}, colors.darkThemed, {
    light: colors.W,
  });
  return themed(defaultThemed);
};

const height = ({compact}) => (
  (compact === 'true') ? 214 : 248
);

const applyBoxShadow = (props) => {
  if (isDefaultThemeMode(props)) {
    return css`
      box-shadow: ${elevation.Z0};
      transition: box-shadow ${duration.fast} ${ease.standard};
      will-change: box-shadow;

      &:hover {
        box-shadow: ${elevation.Z8};
      }
    `;
  }
};

const StyledIconCard = CardBase.extend`
  background-color: ${backgroundColor};
  ${applyBoxShadow};
  color: ${color};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${height}px;
  padding: ${padding};

  &:hover {
    color: ${colors.background};
  }

  @media print {
    display: flex;
    align-items: center;

    &:after {
      color: ${colors.W};
      padding: 0;
    }
  }
`;

export default StyledIconCard;



// WEBPACK FOOTER //
// ./src/elements/Card/styled/StyledIconCard.js